<header [ngClass]="!initialService.partnerpanels ? '!tw-bg-white11za' : ''"
  [style.backgroundColor]="initialService.partnerpanels?.layout_backgroundcolor+' !important' || 'white'"
  [style.top]="'var(--announcement-banner-height, 0px)'"
  class="tw-font-medium tw-p-[12px] tw-flex tw-py-2 tw-items-center tw-select-none tw-fixed tw-w-full tw-z-[999] tw-justify-between tw-shadow-sm tw-border-1 tw-border-b-[1.5px] tw-border-[#D0D1E0] tw-transition-[top] tw-duration-200">
  <!-- Logo Section -->
  <a class="tw-flex tw-items-center" (click)="chatRouter()">
    <img [src]="forClient?initialService.partnerpanels?.main_logo||'':'/images/11zaR.svg'" alt="Logo" draggable="false"
      class=" tw-cursor-pointer tw-h-[35px]" [ngClass]="forClient ? 'tw-w-auto' : 'tw-w-[96px]'">
  </a>

  <!-- <span class="tw-h-[35px] tw-w-[1px] tw-bg-[#D9D9D9] tw-mx-4"></span> -->

  <!-- Middle Navigation Section (Hidden on Mobile) -->
  <!-- [style.color]="isDarkColor(initialService.partnerpanels?.layout_backgroundcolor) ? 'white !important' : 'black'" -->
  <nav class="tw-hidden xl:tw-flex tw-justify-end">
    <a routerLink="analytics"
      [ngClass]="{'tw-text-white':isDarkColor(initialService.partnerpanels?.layout_backgroundcolor)}"
      class="tw-text-headerText tw-px-3 tw-py-1 tw-rounded-md tw-text-sm tw-font-medium tw-flex tw-items-center tw-gap-1 tw-transition-colors tw-duration-300 tw-ease-out hover:tw-text-primary hover:tw-transform tw-relative">
      <i class="tw-text-lg ph-fill ph-chart-line-up"></i> Analytics
      <span
        [ngClass]="{'tw-absolute tw-h-[5px] tw-rounded-t-md tw-bg-primary   tw-w-[calc(100%-40px)] tw-left-1/2 tw-translate-x-[-50%] -tw-bottom-2':isActive('/analytics')}"></span>
    </a>
    <a routerLink="chats"
      [ngClass]="{'tw-text-white':isDarkColor(initialService.partnerpanels?.layout_backgroundcolor)}"
      class="tw-text-headerText tw-px-3 tw-py-1 tw-rounded-md tw-text-sm tw-font-medium tw-flex tw-items-center tw-gap-1 tw-transition-colors tw-duration-300 tw-ease-out hover:tw-text-primary hover:tw-transform tw-relative">
      <i class="tw-text-lg ph-fill ph-chats-circle"></i> Chats
      @if (haderCoundtAndchat.totalChates) {
      <span class="tw-ml-1 tw-px-2 tw-py-0.5 tw-bg-red11za tw-text-white tw-rounded-md"
        [matTooltip]="haderCoundtAndchat.totalChates.toString()" matTooltipPosition="above">
        {{
        haderCoundtAndchat.totalChates >= 1000 ? '999+' :
        (haderCoundtAndchat.totalChates > 99 ? '99+' : haderCoundtAndchat.totalChates)
        }}
      </span>
      }
      <span
        [ngClass]="{'tw-absolute tw-h-[5px] tw-rounded-t-md tw-bg-primary tw-w-[calc(100%-40px)] tw-left-1/2 tw-translate-x-[-50%] -tw-bottom-2':isActive('/chats')}"></span>
    </a>
    @if (!initialService.partnerpanels) {
    <a routerLink="ai_voice"
      [ngClass]="{'tw-text-white':isDarkColor(initialService.partnerpanels?.layout_backgroundcolor)}"
      class="tw-text-headerText tw-px-3 tw-py-1 tw-rounded-md tw-whitespace-nowrap tw-text-sm tw-font-medium tw-flex tw-items-center tw-gap-1 tw-transition-colors tw-duration-300 tw-ease-out hover:tw-text-primary hover:tw-transform tw-relative">
      <i class="tw-text-lg ph-fill ph-microphone"></i> AI Voice
      <span
        class="tw-absolute -tw-top-0 -tw-right-2 tw-bg-gradient-to-r tw-from-green-500 tw-to-green-900 tw-text-white tw-text-[8px] tw-px-[4px] tw-py-[2px] tw-rounded tw-uppercase tw-leading-none ">New</span>
      <span
        [ngClass]="{'tw-absolute tw-h-[5px] tw-rounded-t-md tw-bg-primary tw-w-[calc(100%-40px)] tw-left-1/2 tw-translate-x-[-50%] -tw-bottom-2':isActive('/ai_voice')}"></span>
    </a>
    }
    @if (queuechatsPermission) {
    <a routerLink="queueChats/queue-chat"
      [ngClass]="{'tw-text-white':isDarkColor(initialService.partnerpanels?.layout_backgroundcolor)}"
      class="tw-text-headerText tw-px-3 tw-py-1 tw-rounded-md tw-text-sm tw-font-medium tw-flex tw-items-center tw-gap-1 tw-transition-colors tw-duration-300 tw-ease-out hover:tw-text-primary hover:tw-transform tw-relative">
      <i class="tw-text-lg ph-fill ph-queue"></i> Queue @if (qCount) {
      <span class="tw-ml-1 tw-px-2 tw-py-0.5 tw-bg-red11za tw-text-white tw-rounded-md" [matTooltip]="qCount"
        matTooltipPosition="above">
        {{ qCount }}
      </span>
      }
      <span
        [ngClass]="{'tw-absolute tw-h-[5px] tw-rounded-t-md tw-bg-primary   tw-w-[calc(100%-40px)] tw-left-1/2 tw-translate-x-[-50%] -tw-bottom-2':isActive('/queueChats')}"></span>
    </a>
    }
    @if (endcustomersPermission) {
    <a routerLink="customers"
      [ngClass]="{'tw-text-white':isDarkColor(initialService.partnerpanels?.layout_backgroundcolor)}"
      class="tw-text-headerText tw-px-3 tw-py-1 tw-rounded-md tw-text-sm tw-font-medium tw-flex tw-items-center tw-gap-1 tw-transition-colors tw-duration-300 tw-ease-out hover:tw-text-primary hover:tw-transform tw-relative">
      <i class="tw-text-lg ph-fill ph-users"></i> Customers
      <span
        [ngClass]="{'tw-absolute tw-h-[5px] tw-rounded-t-md tw-bg-primary   tw-w-[calc(100%-40px)] tw-left-1/2 tw-translate-x-[-50%] -tw-bottom-2':isActive('/customers')}"></span>
    </a>
    }
    <!-- Cost capping "Spend Limit" nav badge moved to the default landing page (default-page.component.html),
         shown right under the "Welcome, {name}" heading instead of the header nav. -->
    @if (broadcastsPermission) {
    <a routerLink="broadcast"
      [ngClass]="{'tw-text-white':isDarkColor(initialService.partnerpanels?.layout_backgroundcolor)}"
      class="tw-text-headerText tw-px-3 tw-py-1 tw-rounded-md tw-text-sm tw-font-medium tw-flex tw-items-center tw-gap-1 tw-transition-colors tw-duration-300 tw-ease-out hover:tw-text-primary hover:tw-transform tw-relative">
      <i class="tw-text-lg ph-fill ph-megaphone tw-transform tw-scale-x-[-1]"></i> Broadcast
      <span
        [ngClass]="{'tw-absolute tw-h-[5px] tw-rounded-t-md tw-bg-primary   tw-w-[calc(100%-40px)] tw-left-1/2 tw-translate-x-[-50%] -tw-bottom-2':isActive('/broadcast')}"></span>
    </a>
    }
    @if (templatesPermission) {
    <a routerLink="template"
      [ngClass]="{'tw-text-white':isDarkColor(initialService.partnerpanels?.layout_backgroundcolor)}"
      class="tw-text-headerText tw-px-3 tw-py-1 tw-rounded-md tw-text-sm tw-font-medium tw-flex tw-items-center tw-gap-1 tw-transition-colors tw-duration-300 tw-ease-out hover:tw-text-primary hover:tw-transform tw-relative">
      <i class="tw-text-lg ph-fill ph-swatches"></i> Template
      <span
        [ngClass]="{'tw-absolute tw-h-[5px] tw-rounded-t-md tw-bg-primary   tw-w-[calc(100%-40px)] tw-left-1/2 tw-translate-x-[-50%] -tw-bottom-2':isActive('/template')}"></span>
    </a>
    }
    @if (autorepliesPermission) {
    <a routerLink="chatbot"
      [ngClass]="{'tw-text-white':isDarkColor(initialService.partnerpanels?.layout_backgroundcolor)}"
      class="tw-text-headerText tw-px-3 tw-py-1 tw-rounded-md tw-text-sm tw-font-medium tw-flex tw-items-center tw-gap-1 tw-transition-colors tw-duration-300 tw-ease-out hover:tw-text-primary hover:tw-transform tw-relative">
      <i class="tw-text-lg ph-fill ph-robot"></i> Chatbot
      @if(!initialService.partnerpanels){
      <span
        class="tw-absolute -tw-top-0 -tw-right-2 tw-bg-gradient-to-r tw-from-green-500 tw-to-green-900 tw-text-white tw-text-[8px] tw-px-[4px] tw-py-[2px] tw-rounded tw-uppercase tw-leading-none ">New</span>
      }

      <span
        [ngClass]="{'tw-absolute tw-h-[5px] tw-rounded-t-md tw-bg-primary   tw-w-[calc(100%-40px)] tw-left-1/2 tw-translate-x-[-50%] -tw-bottom-2':isActive('/chatbot')}"></span>
    </a>
    }

    <a routerLink="application"
      [ngClass]="{'tw-text-white':isDarkColor(initialService.partnerpanels?.layout_backgroundcolor)}"
      class="tw-text-headerText tw-px-3 tw-py-1 tw-rounded-md tw-text-sm tw-font-medium tw-flex tw-items-center tw-gap-1 tw-transition-colors tw-duration-300 tw-ease-out hover:tw-text-primary hover:tw-transform tw-relative">
      <i class="tw-text-lg ph-fill ph-squares-four"></i> Apps
      <span
        [ngClass]="{'tw-absolute tw-h-[5px] tw-rounded-t-md tw-bg-primary   tw-w-[calc(100%-40px)] tw-left-1/2 tw-translate-x-[-50%] -tw-bottom-2':isActive('/application')}"></span>
    </a>
  </nav>
  <!-- Hamburger Menu for Mobile -->
  <div class="xl:tw-hidden tw-flex tw-items-center tw-gap-4 tw-ml-auto tw-cursor-pointer">
    <div (click)="onOpenLLineStatusModal()" class="tw-p-1 tw-h-3 tw-w-3 tw-rounded-full tw-relative">
      <span [ngClass]="{'tw-bg-[#ff4c4c]':!isOnline}"
        class="tw-bg-[#11d039] tw-rounded-full tw-h-3 tw-w-3 tw-absolute tw-top-0 tw-left-0 tw-z-10"></span>
      <span [ngClass]="{'tw-bg-[#f05236]':!isOnline}"
        class="tw-bg-primary tw-rounded-full tw-shadow-[0px_-0px_3px_5px] tw-h-full tw-w-full tw-shadow-[#8ce69e] tw-animate-pulse tw-mr-4 tw-absolute tw-left-0 tw-top-0"></span>
    </div>
    <button (click)="toggleMenu()" class="tw-flex tw-items-center tw-justify-center tw-p-1 tw-rounded-md">
      <!-- Menu Icon (hamburger) -->
      @if (!isMenuOpen) {
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
        class="tw-w-6 tw-h-6  tw-transform tw  -transition-transform tw-duration-300 tw-ease-in-out hover:tw-rotate-180">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16m-7 6h7" />
      </svg>
      }

      <!-- Close Icon with scale -->
      @if (isMenuOpen) {
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
        class="tw-w-6 tw-h-6  tw-transform tw-transition-transform tw-duration-300 tw-ease-in-out hover:tw-scale-125">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
      </svg>
      }
    </button>
  </div>


  <!-- User Profile Section -->

  <div class="tw-hidden xl:tw-flex tw-items-center tw-space-x-3 ">
    <!-- <a [href]="baseURL" target="_blank" class="d-flex tw-text-black align-items-center tw-outline tw-outline-1 tw-outline-[#FFDFDF] tw-px-2 tw-p-0 tw-rounded-full">
  Old UI
</a> -->
    @if (isMultiLogin) {
    <div (click)="switchAccount()"
      class="tw-p-2 tw-h-8 tw-w-8 tw-me-2 tw-rounded-full tw-relative tw-flex tw-items-center tw-justify-center tw-bg-gray-200 hover:tw-bg-gray-300 tw-cursor-pointer">
      <i class="ph ph-user-switch tw-text-lg tw-font-bold tw-text-gray-700"></i>
    </div>
    }

    <!-- GLOBAL SEARCH BUTTON -->
    <div class="tw-relative global-search-container tw-mr-2">
      <!-- ALWAYS SHOW ICON -->
      <button (click)="openSearchInput()"
        class="tw-p-2 tw-h-8 tw-w-8 tw-rounded-full tw-flex tw-items-center tw-justify-center hover:tw-bg-gray-200 tw-text-gray-700 tw-transition-colors">
        <i class="ph ph-magnifying-glass tw-text-lg tw-font-bold"></i>
      </button>

      <!-- FLOATING SEARCH BOX -->
      @if (isSearchInputVisible) {
      <!-- Backdrop -->
      <div (click)="closeSearchInput()"
        class="tw-fixed tw-inset-0 tw-bg-slate-900/30 tw-z-40 tw-transition-opacity tw-cursor-default"></div>

      <div
        class="tw-absolute tw-top-full tw-mt-2 tw-right-0 tw-w-80 tw-bg-white tw-shadow-2xl tw-rounded-lg tw-border tw-border-gray-100 tw-z-50 tw-overflow-hidden tw-flex tw-flex-col">
        <!-- Search Input -->
        <div class="tw-flex tw-items-center tw-bg-gray-50 tw-p-2 tw-border-b tw-border-gray-100">
          <span class="tw-pl-2 tw-pr-1 tw-text-gray-400">
            <i class="ph-duotone ph-magnifying-glass tw-text-lg"></i>
          </span>
          <input type="text" #globalSearchInput
            class="tw-w-full tw-bg-transparent tw-text-gray-700 tw-text-sm tw-border-none focus:tw-outline-none tw-px-2"
            placeholder="Search chats..." [(ngModel)]="globalSearchQuery" [debounceTime]="500"
            (debounceEvent)="onGlobalSearch()" (focus)="onGlobalSearch()" />
          <button (click)="closeSearchInput()"
            class="tw-p-1 tw-text-gray-400 hover:tw-text-gray-600 tw-rounded-full hover:tw-bg-gray-200 tw-transition-colors">
            <i class="ph ph-x tw-text-sm"></i>
          </button>
        </div>

        <!-- Dropdown Results -->
        @if (showDropdown && globalSearchQuery.trim()) {
        <div class="tw-max-h-[60vh] tw-overflow-y-auto">
          @if (isSearching) {
          <div class="tw-p-6 tw-flex tw-justify-center tw-items-center tw-text-gray-400 tw-text-sm">
            <i class="ph-duotone ph-spinner ph-spin tw-text-xl tw-mr-2"></i> Searching...
          </div>
          } @else if (searchResults.length === 0) {
          <div class="tw-p-6 tw-flex tw-flex-col tw-items-center tw-text-gray-400 tw-text-sm">
            <i class="ph-duotone ph-magnifying-glass tw-text-3xl tw-mb-2 tw-text-gray-300"></i>
            No results found
          </div>
          } @else {
          @for (chat of searchResults; track chat._id) {
          <div (click)="openChat(chat)"
            class="tw-flex tw-items-center tw-gap-3 tw-p-3 tw-border-b tw-border-gray-50 last:tw-border-0 hover:tw-bg-blue-50 tw-cursor-pointer tw-transition-colors">
            <app-avatar [name]="chat.name || chat.mobileNo" [size]="35"></app-avatar>
            <div class="tw-flex tw-flex-col tw-overflow-hidden tw-w-full">
              <span class="tw-text-sm tw-font-semibold tw-text-gray-800 tw-truncate">{{ chat.name || chat.mobileNo
                }}</span>
              <span class="tw-text-xs tw-text-gray-500 tw-truncate">{{ chat.lastChatMessage || chat.mobileNo }}</span>
            </div>
          </div>
          }
          }
        </div>
        }
      </div>
      }
    </div>

    <div (click)="onOpenLLineStatusModal()" class="tw-p-1 tw-h-3 tw-w-3 tw-rounded-full tw-relative">
      <span [ngClass]="{'tw-bg-[#ff4c4c]':!isOnline}"
        class="tw-bg-[#11d039] tw-rounded-full tw-h-3 tw-w-3 tw-absolute tw-top-0 tw-left-0 tw-z-10"></span>
      <span [ngClass]="{'tw-bg-[#f05236]':!isOnline}"
        class="tw-bg-primary tw-rounded-full tw-shadow-[0px_-0px_3px_5px] tw-h-full tw-w-full tw-shadow-[#8ce69e] tw-animate-pulse tw-mr-4 tw-absolute tw-left-0 tw-top-0"></span>
    </div>

    @if (!forClient) {
    <a href="https://www.youtube.com/@11ZAOfficial" target="_blank"
      class="d-flex tw-text-black align-items-center tw-outline tw-outline-1 tw-outline-[#FFDFDF] tw-px-2 tw-p-0 tw-rounded-full"
      type="button">
      <svg class="tw-text-red11za" width="22" height="28" viewBox="0 0 22 16" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.66667 11.25L14.2892 7.99996L8.66667 4.74996V11.25ZM21.19 2.76746C21.3308 3.27663 21.4283 3.95913 21.4933 4.82579C21.5692 5.69246 21.6017 6.43996 21.6017 7.08996L21.6667 7.99996C21.6667 10.3725 21.4933 12.1166 21.19 13.2325C20.9192 14.2075 20.2908 14.8358 19.3158 15.1066C18.8067 15.2475 17.875 15.345 16.445 15.41C15.0367 15.4858 13.7475 15.5183 12.5558 15.5183L10.8333 15.5833C6.29417 15.5833 3.46667 15.41 2.35083 15.1066C1.37583 14.8358 0.7475 14.2075 0.476667 13.2325C0.335833 12.7233 0.238333 12.0408 0.173333 11.1741C0.0975001 10.3075 0.0649999 9.55996 0.0649999 8.90996L0 7.99996C0 5.62746 0.173333 3.88329 0.476667 2.76746C0.7475 1.79246 1.37583 1.16413 2.35083 0.893293C2.86 0.752459 3.79167 0.654959 5.22167 0.589959C6.63 0.514126 7.91917 0.481626 9.11083 0.481626L10.8333 0.416626C15.3725 0.416626 18.2 0.589959 19.3158 0.893293C20.2908 1.16413 20.9192 1.79246 21.19 2.76746Z"
          fill="#E90505" />
      </svg>
      <!-- <span class="ms-2 tw-text-[#A6A6A6] tw-text-lg">Tutorial</span> -->
    </a>
    }
    <div class="">
      <!-- Dropdown Button -->

      <button [matMenuTriggerFor]="profileMenu"
        class="tw-flex tw-items-center tw-gap-2 tw-bg-lightgreenbg tw-p-1 tw-rounded-full tw-w-full"
        [matTooltip]="userName | titlecase">
        <app-avatar [initialsColorClass]="'tw-bg-primary'" [size]="26" [name]="userName" />
        <span class="tw-text-primary tw-text-sm tw-max-w-28 tw-truncate">
          {{ userName | titlecase }}
        </span>
        <i class="ph-fill ph-caret-down tw-text-sm"></i>
      </button>
      <!-- Dropdown Menu -->
      <mat-menu #profileMenu="matMenu" class="tw-min-w-[260px]">
        <!-- Masters -->
        <div class="tw-px-4 tw-py-2 tw-text-xs tw-font-bold tw-text-gray-700">
          Masters
        </div>
        @if (companyProfilePermission) {
        <button mat-menu-item routerLink="/master/business-profile">Company Profile</button>
        }
        <button mat-menu-item routerLink="/master/my-profile">My Profile</button>

        @if (teamMembersPermission) {
        <button mat-menu-item routerLink="/master/team-members">Team Members</button>
        }

        @if (permission) {
        <button mat-menu-item routerLink="/master/permissions">Permissions</button>
        }

        @if (messagelink) {
        <button mat-menu-item routerLink="/master/messagelink">Message Link</button>
        }

        <mat-divider></mat-divider>

        <!-- File Uploader -->
        @if (fileUploaderPermission) {
        <button mat-menu-item routerLink="/file-upload">File Uploader</button>
        <mat-divider></mat-divider>
        }

        <!-- Messages -->
        <div class="tw-px-4 tw-py-2 tw-text-xs tw-font-bold tw-text-gray-700">
          Messages
        </div>

        @if (quickReplyPermission) {
        <button mat-menu-item routerLink="/messages/quickReplies">Quick Replies</button>
        }

        @if (interactiveMessagePermission) {
        <button mat-menu-item routerLink="/messages/interactive-messages">
          Interactive Messages
        </button>
        }
        @if (compaignFlowPermission) {
        <button mat-menu-item routerLink="/messages/campaign">
          Campaign Flows
        </button>
        }
        <mat-divider></mat-divider>

        <!-- Wallet -->
        @if (walletPermission) {
        <button mat-menu-item routerLink="/wallet/topups">Wallet</button>
        <mat-divider></mat-divider>
        }

        <!-- Settings -->
        <div class="tw-px-4 tw-py-2 tw-text-xs tw-font-bold tw-text-gray-700">
          Settings
        </div>

        @if (optInSettingPermission) {
        <button mat-menu-item routerLink="/settings/opt-in-settings">
          Opt-in Management
        </button>
        }

        @if (logsPermission) {
        <button mat-menu-item routerLink="/settings/logs">Message Logs</button>
        }

        @if (settingsPermission) {
        <button mat-menu-item routerLink="/master/settings">Settings</button>
        }

        @if (allowedIpsPermission) {
        <button mat-menu-item routerLink="/settings/allowed-ips">Allowed IPs</button>
        }

        @if (loginLogsPermission) {
        <button mat-menu-item routerLink="/settings/login-logs">Login Logs</button>
        }

        @if (activityLogsPermission) {
        <button mat-menu-item routerLink="/settings/activity-logs">Activity Logs</button>
        }

        <mat-divider></mat-divider>

        <!-- Logout -->
        <button mat-menu-item class="logout-item" (click)="logout()">
          Logout
        </button>

      </mat-menu>
    </div>
  </div>


</header>

<div [ngClass]="{ 'tw-block': isMenuOpen, 'tw-hidden': !isMenuOpen }"
  class="tw-fixed tw-inset-0 tw-bg-black tw-top-0 tw-bg-opacity-50 tw-z-30" (click)="toggleMenu()">
</div>

<div id="mobile-menu" [ngClass]="{ 'tw-translate-x-0': isMenuOpen, '-tw-translate-x-full': !isMenuOpen }"
  class="tw-hidden tw-overflow-auto tw-select-none xl:tw-hidden tw-transform tw-transition-transform tw-duration-300 tw-ease-in-out tw-bg-gray-800 tw-p-4 tw-fixed tw-top-0 tw-left-0 tw-w-64 tw-h-full tw-z-40 tw-flex-col tw-justify-between">
  <nav class="tw-flex tw-flex-col tw-space-y-2 tw-mt-[80px]">

    <!-- GLOBAL SEARCH FOR MOBILE -->
    <div class="tw-relative global-search-container tw-mb-2">
      <!-- ALWAYS SHOW LINK/ICON -->
      <a (click)="openSearchInput()"
        class="tw-text-white tw-px-3 tw-py-1 tw-rounded-md tw-text-sm tw-font-medium tw-flex tw-items-center tw-gap-1 tw-cursor-pointer hover:tw-text-green-500 tw-transition-colors">
        <i class="tw-text-lg ph-fill ph-magnifying-glass"></i> Global Search
      </a>

      <!-- FLOATING SEARCH BOX -->
      @if (isSearchInputVisible) {
      <!-- Backdrop -->
      <div (click)="closeSearchInput()"
        class="tw-fixed tw-inset-0 tw-bg-black/40 tw-z-40 tw-transition-opacity tw-cursor-default"></div>

      <div
        class="tw-absolute tw-top-full tw-mt-1 tw-left-0 tw-w-full tw-bg-gray-700 tw-shadow-2xl tw-rounded-lg tw-border tw-border-gray-600 tw-z-50 tw-overflow-hidden tw-flex tw-flex-col">
        <!-- Search Input -->
        <div class="tw-flex tw-items-center tw-bg-gray-800 tw-p-2 tw-border-b tw-border-gray-600">
          <span class="tw-pl-2 tw-pr-1 tw-text-gray-400">
            <i class="ph-duotone ph-magnifying-glass tw-text-lg"></i>
          </span>
          <input type="text" #globalSearchInput
            class="tw-w-full tw-bg-transparent tw-text-white tw-text-sm tw-border-none focus:tw-outline-none tw-px-2 placeholder-gray-500"
            placeholder="Search chats..." [(ngModel)]="globalSearchQuery" [debounceTime]="500"
            (debounceEvent)="onGlobalSearch()" (focus)="onGlobalSearch()" />
          <button (click)="closeSearchInput()"
            class="tw-p-1 tw-text-gray-400 hover:tw-text-gray-300 tw-rounded-full hover:tw-bg-gray-600 tw-transition-colors">
            <i class="ph ph-x tw-text-sm"></i>
          </button>
        </div>

        <!-- Dropdown Results Mobile -->
        @if (showDropdown && globalSearchQuery.trim()) {
        <div class="tw-max-h-64 tw-overflow-y-auto">
          @if (isSearching) {
          <div class="tw-p-6 tw-flex tw-justify-center tw-items-center tw-text-gray-400 tw-text-sm">
            <i class="ph-duotone ph-spinner ph-spin tw-text-xl tw-mr-2"></i> Searching...
          </div>
          } @else if (searchResults.length === 0) {
          <div class="tw-p-6 tw-flex tw-flex-col tw-items-center tw-text-gray-400 tw-text-sm">
            <i class="ph-duotone ph-magnifying-glass tw-text-3xl tw-mb-2 tw-text-gray-500"></i>
            No results found
          </div>
          } @else {
          @for (chat of searchResults; track chat._id) {
          <div (click)="openChat(chat)"
            class="tw-flex tw-items-center tw-gap-3 tw-p-3 tw-border-b tw-border-gray-600 last:tw-border-0 hover:tw-bg-gray-600 tw-cursor-pointer tw-transition-colors">
            <app-avatar [name]="chat.name || chat.mobileNo" [size]="35"></app-avatar>
            <div class="tw-flex tw-flex-col tw-overflow-hidden tw-w-full">
              <span class="tw-text-sm tw-font-semibold tw-text-white tw-truncate">{{ chat.name || chat.mobileNo
                }}</span>
              <span class="tw-text-xs tw-text-gray-400 tw-truncate">{{ chat.lastChatMessage || chat.mobileNo }}</span>
            </div>
          </div>
          }
          }
        </div>
        }
      </div>
      }
    </div>

    <a routerLink="analytics" (click)="toggleMenu()"
      class="tw-text-white tw-px-3 tw-py-1 tw-rounded-md tw-text-sm tw-font-medium tw-flex tw-items-center tw-gap-1"
      [ngClass]="{'tw-transition-colors tw-duration-300 tw-ease-out hover:tw-text-green-500 hover:tw-transform': !isActive('/analytics'), 'tw-bg-primary': isActive('/analytics')}">
      <!-- <i class="tw-text-lg ph-fill ph-chats-circle"></i> -->
      <i class="tw-text-lg ph-fill ph-chart-line-up"></i>
      analytics
    </a>
    <a routerLink="/" (click)="toggleMenu()"
      class="tw-text-white tw-px-3 tw-py-1 tw-rounded-md tw-text-sm tw-font-medium tw-flex tw-items-center tw-gap-1"
      [ngClass]="{'tw-transition-colors tw-duration-300 tw-ease-out hover:tw-text-green-500 hover:tw-transform': !isActive('/chats'), 'tw-bg-primary': isActive('/chats')}">
      <i class="tw-text-lg ph-fill ph-chats-circle"></i> Chats
    </a>
    @if (!initialService.partnerpanels) {
    <a routerLink="ai_voice" (click)="toggleMenu()"
      class="tw-text-white tw-px-3 tw-py-1 tw-rounded-md tw-text-sm tw-font-medium tw-flex tw-items-center tw-gap-1"
      [ngClass]="{'tw-transition-colors tw-duration-300 tw-ease-out hover:tw-text-green-500 hover:tw-transform': !isActive('/ai_voice'), 'tw-bg-primary': isActive('/ai_voice')}">
      <i class="tw-text-lg ph-fill ph-microphone"></i> AI Voice
    </a>
    }
    @if (queuechatsPermission) {
    <a routerLink="queueChats/queue-chat" (click)="toggleMenu()"
      class="tw-text-white tw-px-3 tw-py-1 tw-rounded-md tw-text-sm tw-font-medium tw-flex tw-items-center tw-gap-1"
      [ngClass]="{'tw-transition-colors tw-duration-300 tw-ease-out hover:tw-text-green-500 hover:tw-transform': !isActive('/queue'), 'tw-bg-primary': isActive('/queue')}">
      <i class="tw-text-lg ph-fill ph-queue"></i> Queue
    </a>
    }
    @if (endcustomersPermission) {
    <a routerLink="customers" (click)="toggleMenu()"
      class="tw-text-white tw-px-3 tw-py-1 tw-rounded-md tw-text-sm tw-font-medium tw-flex tw-items-center tw-gap-1"
      [ngClass]="{'tw-transition-colors tw-duration-300 tw-ease-out hover:tw-text-green-500 hover:tw-transform': !isActive('/customers'), 'tw-bg-primary': isActive('/customers')}">
      <i class="tw-text-lg ph-fill ph-users"></i> Customers
    </a>
    }
    @if (broadcastsPermission) {
    <a routerLink="broadcast" (click)="toggleMenu()"
      class="tw-text-white tw-px-3 tw-py-1 tw-rounded-md tw-text-sm tw-font-medium tw-flex tw-items-center tw-gap-1"
      [ngClass]="{'tw-transition-colors tw-duration-300 tw-ease-out hover:tw-text-green-500 hover:tw-transform': !isActive('/broadcast'), 'tw-bg-primary': isActive('/broadcast')}">
      <i class="tw-text-lg ph-fill ph-broadcast"></i> Broadcast
    </a>
    }
    @if (templatesPermission) {
    <a routerLink="template" (click)="toggleMenu()"
      class="tw-text-white tw-px-3 tw-py-1 tw-rounded-md tw-text-sm tw-font-medium tw-flex tw-items-center tw-gap-1"
      [ngClass]="{'tw-transition-colors tw-duration-300 tw-ease-out hover:tw-text-green-500 hover:tw-transform': !isActive('/template'), 'tw-bg-primary': isActive('/template')}">
      <i class="tw-text-lg ph-fill ph-swatches"></i> Template
    </a>
    }
    @if (autorepliesPermission) {
    <a routerLink="chatbot" (click)="toggleMenu()"
      class="tw-text-white tw-px-3 tw-py-1 tw-rounded-md tw-text-sm tw-font-medium tw-flex tw-items-center tw-gap-1"
      [ngClass]="{'tw-transition-colors tw-duration-300 tw-ease-out hover:tw-text-green-500 hover:tw-transform': !isActive('/chatbot'), 'tw-bg-primary': isActive('/chatbot')}">
      <i class="tw-text-lg ph-fill ph-robot"></i> Chatbot
    </a>
    }
    <a routerLink="application" (click)="toggleMenu()"
      class="tw-text-white tw-px-3 tw-py-1 tw-rounded-md tw-text-sm tw-font-medium tw-flex tw-items-center tw-gap-1"
      [ngClass]="{'tw-transition-colors tw-duration-300 tw-ease-out hover:tw-text-green-500 hover:tw-transform': !isActive('/apps'), 'tw-bg-primary': isActive('/apps')}">
      <i class="tw-text-lg ph-fill ph-squares-four"></i> Apps
    </a>
  </nav>
  <!-- <div
  class="tw-fixed tw-bottom-0 tw-left-0 tw-bg-gray-800 tw-p-4 tw-flex tw-justify-start tw-items-center tw-gap-2 tw-border-t-2 tw-border-gray-700 tw-w-full"> -->
  <!-- tw-sticky -->
  <div
    class="tw-fixed tw-bottom-0 tw-left-0 tw-w-full tw-bg-gray-800 tw-border-t-2 tw-border-gray-700 tw-p-4 tw-flex tw-items-center">

    <!-- Trigger Button -->
    <button [matMenuTriggerFor]="userMenu"
      class="tw-flex tw-items-center  tw-gap-2 tw-text-white hover:tw-bg-gray-700 tw-rounded-lg tw-px-3 tw-py-2 ">

      <app-avatar [name]="userName | titlecase"></app-avatar>

      <span class="tw-text-white">{{ userName | titlecase }} </span>
      <i class="ph-fill ph-caret-up tw-text-sm tw-text-white"></i>

    </button>

    <!-- MENU -->
    <mat-menu #userMenu="matMenu" class="tw-max-h-[80vh] tw-overflow-y-auto">

      <!-- Masters -->
      <div class="tw-px-4 tw-py-2 tw-text-gray-400 tw-text-sm tw-font-semibold">
        Masters
      </div>

      <button mat-menu-item routerLink="/master/business-profile">
        Company Profile
      </button>

      <button mat-menu-item routerLink="/master/my-profile">
        My Profile
      </button>

      @if (teamMembersPermission) {
      <button mat-menu-item routerLink="/master/team-members">
        Team Members
      </button>
      }

      @if (permission) {
      <button mat-menu-item routerLink="/master/permissions">
        Permissions
      </button>
      }

      @if (messagelink) {
      <button mat-menu-item routerLink="/master/messagelink">
        Message Link
      </button>
      }

      @if (settingsPermission) {
      <button mat-menu-item routerLink="/master/settings">
        Settings
      </button>
      }

      <mat-divider></mat-divider>

      <!-- File Uploader -->
      @if (fileUploaderPermission) {
      <button mat-menu-item routerLink="/file-upload" class="tw-font-semibold">
        File Uploader
      </button>

      <mat-divider></mat-divider>
      }

      <!-- Messages -->
      <div class="tw-px-4 tw-py-2 tw-text-gray-400 tw-text-sm tw-font-semibold">
        Messages
      </div>

      @if (quickReplyPermission) {
      <button mat-menu-item routerLink="/messages/quickReplies">
        Quick Replies
      </button>
      }

      @if (interactiveMessagePermission) {
      <button mat-menu-item routerLink="/messages/interactive-messages">
        Interactive Messages
      </button>
      }



      <mat-divider></mat-divider>

      <!-- Wallet -->
      @if (walletPermission) {
      <button mat-menu-item routerLink="/wallet/topups" class="tw-font-semibold">
        Wallet
      </button>

      <mat-divider></mat-divider>
      }

      <!-- Settings -->
      <div class="tw-px-4 tw-py-2 tw-text-gray-400 tw-text-sm tw-font-semibold">
        Settings
      </div>

      @if (optInSettingPermission) {
      <button mat-menu-item routerLink="/settings/opt-in-settings">
        Opt-in Management
      </button>
      }

      @if (logsPermission) {
      <button mat-menu-item routerLink="/settings/logs">
        Logs
      </button>
      }

      @if (allowedIpsPermission) {
      <button mat-menu-item routerLink="/settings/allowed-ips">
        Allowed IPs
      </button>
      }

      @if (loginLogsPermission) {
      <button mat-menu-item routerLink="/settings/login-logs">
        Login Logs
      </button>
      }

      @if (activityLogsPermission) {
      <button mat-menu-item routerLink="/settings/activity-logs">
        Activity Logs
      </button>
      }

      <mat-divider></mat-divider>

      <!-- Logout -->
      <button mat-menu-item class="logout-item" (click)="logout()">
        Logout
      </button>

    </mat-menu>
  </div>

</div>

<!-- Mobile Menu (Hidden by Default) -->

<ng-template #onLIneStatusModal>
  <!-- Header -->
  <div class="tw-flex tw-items-center tw-justify-between tw-border-b tw-p-4">
    <h2 class="tw-text-lg tw-font-semibold tw-text-gray-700">
      Change Teammember Online Status
    </h2>
    <button class="tw-text-xl tw-text-gray-600" (click)="closeModel()">
      &times;
    </button>
  </div>

  <!-- Body -->
  <div class="tw-p-6 tw-overflow-y-auto">
    <form class="tw-space-y-6" novalidate>
      <!-- Online Status -->
      <div class="tw-flex tw-items-center tw-gap-4">
        <label class="tw-switch">
          <input [(ngModel)]="teamMember.onlineStatus" [ngModelOptions]="{ standalone: true }"
            (change)="onOnlineStatusChange()" type="checkbox" class="tw-sr-only tw-peer">
          <div class="tw-slider tw-round"></div>
        </label>
        <span class="tw-text-sm tw-font-medium tw-text-gray-700">
          Online Status
        </span>
      </div>
      <!-- Offline Options -->
      @if (!teamMember.onlineStatus) {
      <!-- Assign Type -->
      <div class="tw-space-y-3">
        <label class="tw-text-sm tw-font-medium tw-text-gray-700">
          Assign Type <code>*</code>
        </label>
        <div class="tw-flex tw-items-center tw-gap-6">
          <label class="tw-flex tw-items-center tw-gap-2">
            <input type="radio" [value]="true" name="assignTo" appendTo="body" [(ngModel)]="assignToOne"
              [ngModelOptions]="{ standalone: true }" (change)="onAssignTypeChange()" class="tw-h-4 tw-w-4">
            <span class="tw-text-sm">Assign to one</span>
          </label>
          <label class="tw-flex tw-items-center tw-gap-2">
            <input type="radio" [value]="false" name="assignTo" [(ngModel)]="assignToOne" appendTo="body"
              [ngModelOptions]="{ standalone: true }" (change)="onAssignTypeChange()" class="tw-h-4 tw-w-4">
            <span class="tw-text-sm">Assign to a team</span>
          </label>
        </div>
      </div>
      <!-- Assign to One -->
      @if (assignToOne) {
      <div class="tw-space-y-2">
        <label class="tw-text-sm tw-font-medium tw-text-gray-700">
          Who can reply on chat? <code>*</code>
        </label>
        <ng-select [items]="allTeamMembers" bindLabel="name" bindValue="_id" appendTo="body"
          [(ngModel)]="offlineMemberSelect" placeholder="Select Chat" [ngModelOptions]="{ standalone: true }"
          class="tw-w-full">
        </ng-select>
      </div>
      }
      <!-- Assign to Team -->
      @if (!assignToOne) {
      <div class="tw-space-y-4">
        <div class="tw-space-y-2">
          <label class="tw-text-sm tw-font-medium tw-text-gray-700">
            Teams <code>*</code>
          </label>
          <ng-select [items]="allTeams" bindLabel="name" bindValue="_id" [(ngModel)]="selectedTeam" appendTo="body"
            placeholder="Select Teams" [ngModelOptions]="{ standalone: true }"
            (change)="_getTeamMemberforAssign($event._id)" class="tw-w-full">
          </ng-select>
        </div>
        <div class="tw-space-y-2">
          <label class="tw-text-sm tw-font-medium tw-text-gray-700">
            Who can reply on chat? <code>*</code>
          </label>
          <ng-select [items]="allTeamMembers" bindLabel="name" bindValue="_id" appendTo="body"
            [(ngModel)]="offlineMemberSelect" placeholder="Select Reply Chat" [ngModelOptions]="{ standalone: true }"
            class="tw-w-full">
          </ng-select>
        </div>
      </div>
      }
      }
    </form>
  </div>
  <!-- Footer -->
  <div class="tw-flex tw-justify-end tw-gap-3 tw-border-t tw-p-4">
    <button class="save-btn" (click)="saveOnlineStatus()">
      Save
    </button>
  </div>
</ng-template>